import angular from 'angular'
import {saveAs} from 'file-saver/FileSaver'
import moment from 'moment'

let ClientReportController = function (Client, $filter, $scope, $state, Toast, State, City, $timeout) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  $ctrl.search = '';
  $ctrl.searchState = '';
  $scope.colors = ['#8DC73D', '#F78022', '#2B3594', '#ED1B24', '#FDF106', '#2BC0B8', '#CA225F', '#262625',
    '#00A652', '#8D62A9', '#F16029', '#6F2D8F', '#0C0352', '#03CEA4', '#9B1F05', '#F82D69', '#A05A65', '#15FF00',
    '#455110', '#C8B382', '#4E1F24', '#45606E', '#00FF43', '#FF9393', '#606060', '#99AB52', '#E9FD78', '#7CB3B3'];
  $ctrl.filter = {};
  $ctrl.selectedDate = '';

  $timeout(function(){
    angular.element(document.querySelector('.input-search-state')).on('keydown', function (ev) {
      ev.stopPropagation();
    });
  }, 500)

  angular.extend($ctrl, {
    onChangeState, edit, clearSearch
  });


  activate();
  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };
    $ctrl.uiState = 'LOADING';
    loadData()
      .then(response => {
        $ctrl.states = response[0];
        $ctrl.uiState = 'COMPLETE';
        $ctrl.$scope.$apply();
      })
  }

  function clearSearch() {
    $ctrl.search = ''
  };

  $scope.generateChartReport = function () {
    $ctrl.activeSpinButton = true;
    $ctrl.activeSpin = true;
    $ctrl.generationChart = true;
    Client.loadCharts({
      receiver: $ctrl.filter.receiver,
      state: $ctrl.filter.state_id,
      gender: $ctrl.filter.gender,
      city_id: $ctrl.filter.city_id,
      specificationDate: formatDate($ctrl.filter.specificationDate),
        finalDate: formatDate($ctrl.filter.finalDate)
    })
      .then(response => {
        setChartValues(response);
        $ctrl.activeSpin = false;
        $ctrl.graphCreated = true;
        $ctrl.generationChart = false;
        $ctrl.activeSpinButton = false;
      })
  }

  $scope.downloadReport = function () {
    $ctrl.activeSpin = true;
    $ctrl.saving = true;
    $ctrl.activeSpinButton = true;
    Client
      .getReportData({
        receiver: $ctrl.filter.receiver,
        state: $ctrl.filter.state_id,
        gender: $ctrl.filter.gender,
        city_id: $ctrl.filter.city_id,
        specificationDate: formatDate($ctrl.filter.specificationDate),
        finalDate: formatDate($ctrl.filter.finalDate)
      })
      .then(function (res) {
        $ctrl.activeSpin = false;
        $ctrl.saving = false;
        $ctrl.activeSpinButton = false;
        const file = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        saveAs(file, 'rel_analitico_clientes.csv');
      }).catch(err => {
        console.log('err:' ,  err);
        let messageError = $filter('translate')('report-error');
        $ctrl.activeSpin = false;
        $ctrl.saving = false;
        $ctrl.activeSpinButton = false;
        Toast.error(messageError);
      });

    // Client
    // .getReportData()
    // .then(function (res) {
    //   let messageSuccess = $filter('translate')('report-success');
    //   $ctrl.activeSpin = false;
    //   $ctrl.activeSpinButton = false;
    //   Toast.success(messageSuccess);
    //   window.location.href = res.url;
    // }).catch(err => {
    //   console.log('err:' ,  err);
    //   let messageError = $filter('translate')('report-error');
    //   $ctrl.activeSpin = false;
    //   $ctrl.activeSpinButton = false;
    //   Toast.error(messageError);
    // });
  };

  $scope.downloadReportSmall = function () {
    $ctrl.activeSpinSmall = true;
    $ctrl.activeSpinSmallButton = true;
    Client
      .downloadReportSmall()
      .then(function (res) {
        let messageSuccess = $filter('translate')('report-success');
        $ctrl.activeSpinSmall = false;
        $ctrl.activeSpinSmallButton = false;
        Toast.success(messageSuccess);
        window.location.href = res.url;
      }).catch(err => {
      console.log('err:', err);
      let messageError = $filter('translate')('report-error');
      $ctrl.activeSpinSmall = false;
      $ctrl.activeSpinSmallButton = false;
      Toast.error(messageError);
    });
  };

  function onChangeState(stateId) {
    if(stateId && stateId.length === 1) {
      // if(stateId && stateId.length > 1)
      $ctrl.filter.city_id = null;
      $ctrl.loadingCities = true;
      City
        .listCitiesWithClient({
          state_id: stateId,
          limit: 1000000
        })
        .then(cities => {
          $ctrl.cities = cities;
          $ctrl.loadingCities = false;
        })
        .catch(err => {
          console.log('err:', err);
          $ctrl.loadingCities = false;
        }).finally(()=> {
          angular.element(document.querySelector('.input-search-city')).on('keydown', function (ev) {
            ev.stopPropagation();
          });
        });
    }

    if(stateId && stateId.length > 1) {
      $ctrl.search = ''
      $ctrl.filter.city_id = null;
      $ctrl.cities = [];
    }
  }

  function edit(id) {
    $state.go('client.edit', {id});
  }

  // Local functions
  function loadData() {
    let promises = [];
    promises.push(State.listStatesWithClient());
    return Promise.all(promises);
  }

  function setChartValues(json) {
    $scope.labelsClients = ["Médicos", "Clientes", "Dependentes"];
    $scope.dataClients = [json.type.countMedic, json.type.countClient, json.type.countDependents];
    $scope.labelsClientsGender = ["Masculino", "Feminino", "Outros", "Não informado"];
    $scope.dataClientsGender = [json.gender.countMale, json.gender.countFemale, json.gender.countOther, json.gender.countNull];
    $scope.labelsDependents = ["Possui dependentes", "Não possui dependentes"];
    $scope.dataDependents = [json.dependent.countWith, json.dependent.countWithout];
    $scope.labelsStates = []
    $scope.dataStates = []
    json.states.forEach((state) => {
      $scope.labelsStates.push(state.uf)
      $scope.dataStates.push(state.total)
    })
    $scope.labelsCities = []
    $scope.dataCities = []
    json.cities.forEach((city) => {
      $scope.labelsCities.push(city.name)
      $scope.dataCities.push(city.total)
    })
  }

  $scope.maxPeriod = new Date(new Date().getUTCFullYear() + 1)
  $scope.setMaxYear = function () {
    $ctrl.filter.finalDate = null;
    $scope.maxPeriod = new Date(`${$ctrl.filter.specificationDate.getUTCFullYear() + 1} ${$ctrl.filter.specificationDate.getUTCMonth() + 1} 1`)
  }

  function formatDate(dt) {
    return dt ? moment(dt).format("YYYY-MM-DD") : null;
  }
}

ClientReportController.$inject = ['Client', '$filter', '$scope', '$state', 'Toast', 'State', 'City', '$timeout'];
export default ClientReportController;



// WEBPACK FOOTER //
// ./client/app/components/client/client-report.controller.js